import { Link } from 'react-router-dom';
import { Youtube, Linkedin, Twitter, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-primary text-primary-foreground mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1">
            <h3 className="text-xl font-bold mb-4">The Customer First Business</h3>
            <p className="text-sm opacity-90">Transforming businesses through servant leadership and customer-first principles.</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/about" data-testid="footer-about" className="opacity-90 hover:opacity-100 hover:underline transition-opacity">
                  About
                </Link>
              </li>
              <li>
                <Link to="/book" data-testid="footer-book" className="opacity-90 hover:opacity-100 hover:underline transition-opacity">
                  The Book
                </Link>
              </li>
              <li>
                <Link to="/coaching" data-testid="footer-coaching" className="opacity-90 hover:opacity-100 hover:underline transition-opacity">
                  Coaching Services
                </Link>
              </li>
              <li>
                <Link to="/speaking" data-testid="footer-speaking" className="opacity-90 hover:opacity-100 hover:underline transition-opacity">
                  Speaking Engagements
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-semibold mb-4">Resources</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/resources" data-testid="footer-resources" className="opacity-90 hover:opacity-100 hover:underline transition-opacity">
                  YouTube Channel
                </Link>
              </li>
              <li>
                <Link to="/contact" data-testid="footer-contact" className="opacity-90 hover:opacity-100 hover:underline transition-opacity">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="font-semibold mb-4">Connect</h4>
            <div className="flex space-x-4">
              <a
                href="https://youtube.com/@TheServantCEO"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-youtube"
                className="p-2 rounded-full hover:bg-accent hover:text-accent-foreground transition-colors"
                aria-label="YouTube"
              >
                <Youtube size={20} />
              </a>
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-linkedin"
                className="p-2 rounded-full hover:bg-accent hover:text-accent-foreground transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-twitter"
                className="p-2 rounded-full hover:bg-accent hover:text-accent-foreground transition-colors"
                aria-label="Twitter"
              >
                <Twitter size={20} />
              </a>
              <a
                href="mailto:info@customerfirstbusiness.com"
                data-testid="social-email"
                className="p-2 rounded-full hover:bg-accent hover:text-accent-foreground transition-colors"
                aria-label="Email"
              >
                <Mail size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-primary-foreground/20 mt-8 pt-8 text-center text-sm opacity-90">
          <p>&copy; {new Date().getFullYear()} Servant CEO. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;